import { useEffect, useState } from 'react'

import { useOrderFormStore } from '@/modules/order/stores/order-form.store'

import { useProductStore } from '../stores/product.store'
import type { TProducts } from '../types/product.type'

export const useGetProductFromOrderHook = () => {
  const { jsonOrderForm } = useOrderFormStore()
  const { productIdSelected } = useProductStore()
  const [product, setProduct] = useState<TProducts>(null)

  useEffect(() => {
    if (jsonOrderForm && productIdSelected) {
      setProduct(
        jsonOrderForm.itemsCalculo.find(
          (product) => product.fkProduto === productIdSelected,
        ),
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jsonOrderForm, productIdSelected])

  return {
    product,
  }
}
